import { FileDocumentPlusOutlineIcon } from './FileDocumentPlusOutlineIcon';

/**
 * author: Simran
 * id 99FAD22E-FB80-45AA-9423-3E4E2A369F1F
 * name file-document-plus-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-plus-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileTextAddOutlineIcon = FileDocumentPlusOutlineIcon;
export default FileTextAddOutlineIcon